import { isPlainObject } from 'lodash';
import type { ActionContext } from '@/interfaces/common';
import $rq from '@/api/api';

const defaultLang = 'en';

interface SiteLangGetter {
    site: {
        lang: string;
    };
    labWorkOrder: {
        site: {
            lang: string;
        };
    };
    lang: string;
}

interface LangGetter {
    lang: string;
    user: {
        lang: string;
    };
}

interface LangState {
    lang: string;
    availableTeamLangs: string[];
}

/**
 * Old code using the getter lang, we should use userLang or siteLang getters.
 */
export default {
    state: {
        lang: defaultLang,
        availableTeamLangs: [],
    },
    mutations: {
        SET_TEAM_LANGS(state: LangState, langs: string[]) {
            state.availableTeamLangs = langs;
        },
    },
    actions: {
        langsAvailableByTeam(
            { commit }: { commit: (type: string, payload: string[]) => void },
            langs: string[],
        ) {
            commit('SET_TEAM_LANGS', langs);
        },

        async loadTeamLangs({ dispatch }: ActionContext, teamId: string) {
            try {
                const { data } = await $rq.getTeamInfo(teamId);
                const langsAvailable = [data.lang, ...(data.optionalLangs || [])];
                dispatch('langsAvailableByTeam', langsAvailable);
            } catch {
                dispatch('resetWorkOrderInfo');
            }
        },
    },
    getters: {
        lang: (state: object, getters: LangGetter): string => {
            const { user } = getters;

            if (!isPlainObject(user)) {
                return defaultLang;
            }

            return user.lang;
        },

        // this is sugarcoat for user.lang
        userLang: (state: object, getters: LangGetter): string => getters.lang,

        siteLang: (state: object, getters: SiteLangGetter): string => {
            const { site, labWorkOrder, lang } = getters;
            if (!isPlainObject(site)) {
                return defaultLang;
            }
            return (
                site.lang ||
                (isPlainObject(labWorkOrder) && labWorkOrder.site ? labWorkOrder.site.lang : '') ||
                lang ||
                defaultLang
            );
        },

        teamLangs: (state: LangState): string[] => state.availableTeamLangs,
    },
};
